const MultiCheckMixin = {
    data() {
        return {
            lastChecked: null,
        };
    },
    methods: {
        handleMultiCheck(event, callback = (element) => {}) {
            const element = event.target;
            const elementClass = element.className;

            if (!this.lastChecked) {
                this.lastChecked = element;
                callback(element);
                return;
            }

            if (event.shiftKey) {
                let checkboxes = $(`.${elementClass}`);
                let start = checkboxes.index(element);
                let end = checkboxes.index(this.lastChecked);

                checkboxes
                    .slice(Math.min(start, end), Math.max(start, end) + 1)
                    .each((index, checkbox) => {
                        $(checkbox).prop("checked", this.lastChecked.checked);
                        if (checkboxes.index(checkbox) == end) return;
                        callback(checkbox);
                    });
            }

            this.lastChecked = element;
            if (!event.shiftKey) {
                callback(element);
            }
        },
    },
};

export default MultiCheckMixin;
